import React, { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Prompt, useHistory } from "react-router-dom";
import { Confirm } from "semantic-ui-react";

const UnsavedChangesRoutePrompt = ({ isDirty, header, content }) => {
    const history = useHistory();
    const confirmedNavigationRef = useRef(false);
    const pendingLocationRef = useRef(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const handleBlockedNavigation = useCallback((nextLocation) => {
        if (confirmedNavigationRef.current || !isDirty) {
            return true;
        }
        pendingLocationRef.current = nextLocation;
        setIsConfirmOpen(true);
        return false;
    }, [isDirty]);

    const handleConfirm = () => {
        confirmedNavigationRef.current = true;
        setIsConfirmOpen(false);
        if (pendingLocationRef.current) {
            history.push(pendingLocationRef.current);
        }
    };

    const handleCancel = () => {
        setIsConfirmOpen(false);
        pendingLocationRef.current = null;
    };

    return (
        <>
            <Prompt when={isDirty} message={handleBlockedNavigation} />
            <Confirm
                open={isConfirmOpen}
                header={header}
                content={content}
                onCancel={handleCancel}
                onConfirm={handleConfirm}
            />
        </>
    );
};

UnsavedChangesRoutePrompt.propTypes = {
    isDirty: PropTypes.bool.isRequired,
    header: PropTypes.string,
    content: PropTypes.string,
};

export default UnsavedChangesRoutePrompt;
